<template>
  <div
    class="text-center margin-top-20 margin-bottom-20"
    :class="{ invisible: !loading }"
  >
    <loader />
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
  },
}
</script>
